import { useQuery } from "@tanstack/react-query";
import {
  getCustomerReferral,
  getPendingReferrals,
  getReferralConfig,
} from "hooks/api/referral";

export const useReferralConfig = () =>
  useQuery({
    queryKey: ["referral", "config"],
    queryFn: getReferralConfig,
  });

export const usePendingReferrals = () =>
  useQuery({
    queryKey: ["referral", "pending"],
    queryFn: getPendingReferrals,
  });

export const useCustomerReferral = (customerId?: string, enabled = true) =>
  useQuery({
    queryKey: ["referral", "customer", customerId],
    queryFn: () => getCustomerReferral(customerId!),
    enabled: enabled && !!customerId,
  });
